import axios from "axios";

const BASE_URL = process.env.REACT_APP_PUBLIC_API_URL;
const api = axios.create({
  baseURL: BASE_URL,
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
  },
});

export default api;
